module.exports = __webpack_public_path__ + "static/media/USAToday.0f9f9001.png";